import {createRouter, createWebHistory} from 'vue-router'
import CheckComponent from "@/views/Check-Component.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import LoginComponent from "@/views/Login-Component.vue";
import EvidenciaComponent from "@/views/Evidencia-Component.vue";
import DashboardComponent from "@/views/Dashboard-Component.vue";
import CargaMasivaComponent from "@/views/CargaMasiva-Component.vue";
import ClientesComponent from '@/views/Clientes-Component.vue';
import SucursalComponent from '@/views/Sucursal-Component.vue';
import HomeView from "@/views/HomeView.vue";
import { inject } from 'vue'
import AreaSucursalComponent from "@/views/Area-Sucursal-Component.vue";
import EmpleadosComponent from "@/views/Empleados-Component.vue";
import TIERComponent from "@/views/TIER-Component.vue";
import adminPermisosComponent from "@/views/adminPermisos-Component.vue";
import adminPerfilesComponent from "@/views/adminPerfiles-Component.vue";

function guard(permiso, next) {
  const storage = inject('$localStorageService')
  try {
    if (storage.isAuth()) {
      if (permiso == null || storage.can(permiso)) {
        next();
      } else {
        next({
          name: "home"
        });
      }
    } else {
      console.info("NO LOGEADO")
      next({
        name: "login"
      });
    }
  } catch (e) {
    console.info(e);
    next({
      name: "login"
    });
  }
}

const routes = [
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
  { path: '/', component: LoginComponent, name: 'inicio' },
  { path: '/login', component: LoginComponent, name: 'login' },

  { path: '/dashboard', component: DashboardComponent, name: 'dashboard',
    beforeEnter: (to, from, next) => {
      guard('api.DASHBOARD', next);
    }
  },
  { path: '/tier', component: TIERComponent, name: 'tier',
    beforeEnter: (to, from, next) => {
      guard('api.REPORTE_TIER', next);
    }
  },
  { path: '/registrarEvento', component: CheckComponent, name: 'registrarEvento',
    beforeEnter: (to, from, next) => {
      guard('api.REGISTRO_ASISTENCIA', next);
    }
  },

  { path: '/registrarEvidencia', component: EvidenciaComponent, name: 'registrarEvidencia' ,
    beforeEnter: (to, from, next) => {
      guard('api.REGISTRO_EVIDENCIA', next);
    }
  },

  { path: '/cargaMasiva', component: CargaMasivaComponent, name: 'setup' ,
    beforeEnter: (to, from, next) => {
      guard('api.ADM_CARGA_MASIVA', next);
    }
  },

  { path: '/home', component: HomeView, name: 'home',
    beforeEnter: (to, from, next) => {
      guard(null, next);
    }
  },

  { path: '/empleados', component: EmpleadosComponent, name: 'empleados' ,
    // beforeEnter: (to, from, next) => {
    //   guard('api.ADM_EMPLEADOS', next);
    // }
  },

  { path: '/adminPermisos', component: adminPermisosComponent, name: 'adminPermisos' ,
    beforeEnter: (to, from, next) => {
      guard('api.ADM_PERMISOS', next);
    }
  },

  { path: '/adminPerfiles', component: adminPerfilesComponent, name: 'adminPerfiles' ,
    // beforeEnter: (to, from, next) => {
    //   guard('api.ADM_PERFILES', next);
    // }
  },

  { path: '/clientes', component: ClientesComponent, name: 'clientes' ,
    beforeEnter: (to, from, next) => {
      guard('api.ADM_CLIENTES', next);
    }
  },

  { path: '/sucursales', component: SucursalComponent, name: 'sucursales' ,
    beforeEnter: (to, from, next) => {
      guard('api.ADM_SUCURSALES', next);
    }
  },

  { path: '/areas_sucursal', component: AreaSucursalComponent, name: 'areas_sucursal' ,
    beforeEnter: (to, from, next) => {
      guard('api.ADM_AREAS_SUCURSAL', next);
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
